import { toast } from 'react-toastify';

import { requestComplete, requestError, requestStarted } from './http-request';
import { checkUserByEmail, fetchUsername, loginWithEmail, register } from '../../sell/api/login';
import { setLoginModalStep } from '../../sell/actions/sell-tickets';
import { forgotPassword } from '../../sell/api/sell';
import { decoratePayloadContactDetails } from '../../cart/api/decorator';
import { handleRequestErrors } from '../../cart/actions/forms';
import { API_BASE_URL, AUTH_REQUEST_NAME } from '../../cart/api/config';
import { BASE_API_SOCIAL_CONNECT } from '../../sell/api/config';
import { LOGIN_STEP_2, LOGIN_STEP_3 } from '../../sell/constants/modal';
import { STATUS_AUTH_FAILED, STATUS_AUTH_LOADING, STATUS_AUTH_SUCCEEDED } from '../reducers/auth';
import { USER_FORM } from '../../cart/reducers/features/user';

export const SET_PHONE_USER = 'SET_PHONE_USER';
export const setPhoneUser = (phone) => ({
    type: SET_PHONE_USER,
    payload: phone,
});
export const SET_EMAIL_USER = 'SET_EMAIL_USER';
export const setEmailUser = (email) => ({
    type: SET_EMAIL_USER,
    payload: email,
});

export const SET_CONFIRM_EMAIL_USER = 'SET_CONFIRM_EMAIL_USER';
export const setConfirmEmailUser = (email) => ({
    type: SET_CONFIRM_EMAIL_USER,
    payload: email,
});

export const SET_PASSWORD_USER = 'SET_PASSWORD_USER';
export const setPasswordUser = (password) => ({
    type: SET_PASSWORD_USER,
    payload: password,
});
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const loginFailure = (error) => ({
    type: LOGIN_FAILURE,
    payload: error,
});
export const REGISTER_FAILURE = 'REGISTER_FAILURE';
export const registerFailure = (error) => ({
    type: REGISTER_FAILURE,
    payload: error,
});
export const SET_USERNAME = 'SET_USERNAME';
export const setUsername = (username) => ({
    type: SET_USERNAME,
    payload: username,
});
export const SET_STATUS = 'SET_STATUS';
export const setAuthStatus = (status) => ({
    type: SET_STATUS,
    payload: status,
});

export const SET_FIRST_NAME = 'SET_FIRST_NAME';
export const setFirstName = (firstName) => ({
    type: SET_FIRST_NAME,
    payload: firstName,
});
export const SET_LAST_NAME = 'SET_LAST_NAME';
export const setLastName = (lastName) => ({
    type: SET_LAST_NAME,
    payload: lastName,
});
export const SET_ALLOW_RECOMMENDATIONS = 'SET_ALLOW_RECOMMENDATIONS';
export const setAllowRecommendations = (allowRecommendations) => ({
    type: SET_ALLOW_RECOMMENDATIONS,
    payload: allowRecommendations,
});

export const doCheckUserByEmail = (email) => async (dispatch) => {
    try {
        dispatch(requestStarted(AUTH_REQUEST_NAME));
        const response = await checkUserByEmail(email);
        const formattedResponse = await response.json();
        if (formattedResponse.account !== 'iabilet') {
            dispatch(setLoginModalStep(LOGIN_STEP_2));
        } else {
            dispatch(setLoginModalStep(LOGIN_STEP_3));
        }
    } catch (e) {
        dispatch(requestError(AUTH_REQUEST_NAME));
    } finally {
        dispatch(requestComplete(AUTH_REQUEST_NAME));
    }
};

export const doLoginWithEmail = (email, password, goToNextStep) => async (dispatch) => {
    try {
        dispatch(requestStarted(AUTH_REQUEST_NAME));

        const response = await loginWithEmail(email, password);
        const formattedResponse = await response.json();
        if (formattedResponse.status === 'error') {
            dispatch(loginFailure(formattedResponse.message));
            return;
        }
        dispatch(setAuthStatus(STATUS_AUTH_SUCCEEDED));
        dispatch(setUsername(formattedResponse.username));
        goToNextStep();
    } catch (e) {
        dispatch(requestError(AUTH_REQUEST_NAME));
    } finally {
        dispatch(requestComplete(AUTH_REQUEST_NAME));
    }
};

export const doForgotPassword = (email) => async () => {
    const response = await forgotPassword({ email });
    const formattedResponse = await response.json();
    if (formattedResponse.status === 'error') {
        toast.error(formattedResponse.message);
        return;
    }
    toast.success(formattedResponse.message);
};

export const doSocialConnect = (provider, targetPath) => {
    window.location.href = `${API_BASE_URL}${BASE_API_SOCIAL_CONNECT}/${provider}?target_path=${targetPath}`;
};

export const getUsername = () => async (dispatch) => {
    try {
        dispatch(setAuthStatus(STATUS_AUTH_LOADING));
        const response = await fetchUsername();
        const username = await response.json();
        dispatch(setUsername(username));
        if (username) {
            dispatch(setAuthStatus(STATUS_AUTH_SUCCEEDED));
        } else {
            dispatch(setAuthStatus(STATUS_AUTH_FAILED));
        }
    } catch (e) {
        dispatch(setAuthStatus(STATUS_AUTH_FAILED));
    }
};

export const doRegister = (inputs, goToNextStep) => async (dispatch) => {
    try {
        dispatch(requestStarted(AUTH_REQUEST_NAME));
        const payload = decoratePayloadContactDetails(inputs);
        const response = await register(payload);
        const formattedResponse = await response.json();
        if (formattedResponse.status === 'error') {
            if (formattedResponse.errors) {
                handleRequestErrors(USER_FORM, formattedResponse, dispatch);
            } else {
                dispatch(registerFailure(formattedResponse.message));
            }
            return;
        }
        dispatch(setAuthStatus(STATUS_AUTH_SUCCEEDED));
        dispatch(setUsername(formattedResponse.username));
        goToNextStep();
    } catch (e) {
        dispatch(requestError(AUTH_REQUEST_NAME));
    } finally {
        dispatch(requestComplete(AUTH_REQUEST_NAME));
    }
};
